import { Dispatch } from "redux";
import routing from "../../../routing";
import routingStartsWith from "../../../../common/helpers/routingStartsWith";
import { hasItem, setItem } from "../../../cookie";
import { IStateTree } from "../../interfaces";

import { GET_PLAN } from "../types";
import { AxiosInstance, AxiosResponse } from "axios";
import { IPlan } from "../../../../common/types";
import { IGetPlan } from "../models/planActions";
import { IUser } from "../../user/models";

export default (path: string, callback?: (res: AxiosResponse<{ plan: IPlan, found: boolean }>) => void) =>
    async (dispatch: Dispatch<IGetPlan>, getState: () => IStateTree, api: AxiosInstance) => {
    dispatch({
        type: GET_PLAN,
        payload: {
            loading: true,
        },
    });
    let publicView =
        path.slice(1, routing.publicPlan.length + 1) === routing.publicPlan ||
        path.slice(1, routing.publicPlay.length + 1) === routing.publicPlay ||
        path.slice(1, routing.testModeration.length + 1) === routing.testModeration ||
        path.slice(1, routing.share.length + 1) === routing.share;
    const url = publicView ? "public-plan" : "plan";
    let idStartsAt = 0;
    if (routingStartsWith(path, routing.plan + "/")) {
        idStartsAt = routing.plan.length + 1;
    } else if (routingStartsWith(path, routing.play + "/")) {
        idStartsAt = routing.play.length + 1;
    } else if (routingStartsWith(path, routing.publicPlan + "/")) {
        idStartsAt = routing.publicPlan.length + 1;
    } else if (routingStartsWith(path, routing.publicPlay + "/")) {
        idStartsAt = routing.publicPlay.length + 1;
    } else if (routingStartsWith(path, routing.share + "/")) {
        idStartsAt = routing.share.length + 1;
    } else if (routingStartsWith(path, routing.testModeration + "/")) {
        idStartsAt = routing.testModeration.length + 1;
    }
    let planId = path.slice(idStartsAt + 1, idStartsAt + 1 + 24);
    let anonymousFirstView = false;
    if (publicView && (!getState().user || !(getState().user as IUser).loggedIn)) {
        if (!hasItem("plan_" + planId)) {
            anonymousFirstView = true;
            setItem("plan_" + planId, "1", 60 * 60 * 24 * 365, "/");
        }
    }
    try {
        const res = await api.get<{ plan: IPlan, found: boolean }>(`/${url}?planId=${planId}&anonymous=${anonymousFirstView}`);
        dispatch({
            type: GET_PLAN,
            payload: res,
        });
        if (callback) {
            callback(res);
        }
    } catch (error) {
        dispatch({
            type: GET_PLAN,
            payload: {
                error: true,
                notFound: error?.response?.status === 404,
            },
        });
    }
};